export default __webpack_public_path__ + "static/media/ondemand_active.0e7eb501.svg";